<template>
  <div class="gameBox">
      <div class="gameHeader">
          <a class="iphone" @click="jumpIphone">Xem chi tiết chương trình >></a>
          <a class="winner" @click="jumpWinner">Kết quả quay số trúng thưởng >></a>
      </div>
      <!-- <div class="gameContent">
          <a href="http://lottery.headlines.pw/static/history.html">Bạn đọc trúng giải kỳ trước >></a>
      </div> -->
      <div class="gameFooter">
          <p>THỜI HẠN CHƯƠNG TRÌNH: 05/11/2018 – 30/06/2019</p>
          <button>
              <a href="https://play.google.com/store/apps/details?id=com.xb.topnews">Tải ngay</a>
          </button>
      </div>
  </div>
</template>

<script>
export default {
  name: 'GameRule',
  methods: {
    jumpIphone () {
      this.$router.push({path: '/introduction'})
    },
    jumpWinner () {
      this.$router.push({path: '/winner'})
    }
  }
}
</script>
<style scoped>
.gameBox {
  display: block;
  position: relative;
  width: 1000px;
  margin: 0 auto;
  text-align: center;
  font-size: 24px;
  color: #f72442;
  padding: 45px 100px 32px 100px;
}
a {
  font-size: 24px;
  color: #f72442;
  text-decoration: none;
}
.gameHeader {
  position: relative;
  width: 800px;
  height: 360px;
  background-image: url("../assets/image/gameBG.jpg");
  background-repeat: no-repeat;
  background-size: 100% auto;
}
.gameHeader .iphone {
  display: inline-block;
  position: absolute;
  left: 25px;
  top: 58px;
}
.gameHeader .winner {
  display: inline-block;
  position: absolute;
  left: 25px;
  top: 100px;
  font-size: .8em
}
.gameContent {
  position: relative;
  margin-top: 80px;
  margin-bottom: 80px;
}
.gameFooter button {
  width: 200px;
  height: 60px;
  line-height: 60px;
  margin-top: 60px;
  margin-bottom: 100px;
  background-color: #f72442;
  border-radius: 10px;
  border: none;
}
.gameFooter a {
  font-size: 24px;
  color: #ffffff;
  text-decoration: none;
}
</style>




// WEBPACK FOOTER //
// GameRule.vue?1c2a92db